// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-pipe-component-details {
  display: contents;
}

th {
  border: 1px solid silver;
  background-color: #f7f7f7;
  font-weight: bold;
}

thead th:nth-child(1) {
  text-align: left;
}

thead th:nth-child(2) {
  text-align: center;
}

thead th:nth-child(3) {
  text-align: center;
}

thead th:nth-child(4) {
  text-align: center;
}

thead th:nth-child(5) {
  text-align: left;
}

thead th:nth-child(6) {
  text-align: center;
}

thead th:nth-child(7) {
  text-align: center;
}

table {
  border: 1px solid silver;
}

table tr th, table tr td {
  padding: 4px 6px;
}

.table-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.edit-button-container {
  display: flex;
  gap: 10px;
}

.edit-button {
  background-color: #0D47A1;
  color: white;
}
.edit-button:hover {
  background-color: #1565C0;
}

.edit-button mat-icon {
  margin-right: 8px;
}

.save-button {
  background-color: #0D47A1;
  color: white;
}
.save-button:hover {
  background-color: #1565C0;
}

.cancel-button {
  background-color: #f44336;
  color: white;
}
.cancel-button:hover {
  background-color: #d32f2f;
}

.save-button mat-icon,
.cancel-button mat-icon {
  margin-right: 8px;
}

.comments-container {
  margin-top: 20px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
